// Mock data for Pravak Global Exports

export const companyInfo = {
  name: "Pravak Global Exports",
  tagline: "Premium Leather Craftsmanship from India",
  description: "Pravak Global Exports is a dedicated leather goods export company based in India, committed to delivering premium quality leather products to international markets. We specialize in sourcing and exporting fine leather goods including bags, wallets, and purses, ensuring excellence in craftsmanship and competitive wholesale pricing.",
  founded: "2025",
  team: 3,
  location: "Om Chambers, Binnamangala, Stage 1, Indiranagar, Bengaluru, Karnataka 560038",
  email: "support@pravakglobalexports.com",
  phone: "+91 XXXXX XXXXX",
  address: "Om Chambers, Binnamangala, Stage 1, Indiranagar, Bengaluru, Karnataka 560038"
};

export const leatherCategories = [
  {
    id: 1,
    title: "Leather Bags",
    description: "Premium leather bags including briefcases, satchels, and travel bags. Crafted with precision for international markets."
  },
  {
    id: 2,
    title: "Leather Wallets",
    description: "Handcrafted leather wallets with superior quality materials. Available in various styles and designs for wholesale."
  },
  {
    id: 3,
    title: "Leather Purses",
    description: "Elegant leather purses and handbags combining traditional craftsmanship with modern designs for global buyers."
  },
  {
    id: 4,
    title: "Leather Belts",
    description: "Durable and stylish leather belts designed for both formal and casual wear. High-quality materials ensure long-lasting performance."
  },
  {
    id: 5,
    title: "Leather Gloves for Industry",
    description: "Industrial-grade leather gloves providing safety and comfort for various industrial applications. Built to meet international safety standards."
  },
  {
    id: 6,
    title: "Leather Jackets",
    description: "Premium leather jackets combining style and durability. From classic designs to contemporary fashion, crafted for international markets."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Premium Quality",
    description: "We source only the finest leather materials and work with skilled artisans to ensure every product meets international quality standards."
  },
  {
    id: 2,
    title: "Export Excellence",
    description: "Extensive experience in international shipping, documentation, and compliance with global trade regulations for seamless exports."
  },
  {
    id: 3,
    title: "Competitive Wholesale Pricing",
    description: "Direct sourcing relationships and efficient operations enable us to offer competitive pricing for bulk orders."
  },
  {
    id: 4,
    title: "Customization Services",
    description: "Flexible customization options including branding, packaging, and design modifications to meet your specific business requirements."
  },
  {
    id: 5,
    title: "Reliable Partnership",
    description: "Committed to building long-term relationships with our international clients through transparency and consistent quality."
  },
  {
    id: 6,
    title: "Indian Craftsmanship",
    description: "Leveraging India's rich heritage in leather craftsmanship, we bring authentic quality and traditional techniques to modern designs."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Founder & CEO",
    role: "Business Development & Strategy",
    description: "Leading international partnerships and strategic growth initiatives to expand our presence in global leather markets."
  },
  {
    id: 2,
    name: "Co-Founder",
    role: "Operations & Quality Control",
    description: "Ensuring product excellence through rigorous quality checks and efficient supply chain management."
  },
  {
    id: 3,
    name: "Co-Founder",
    role: "Export Compliance & Documentation",
    description: "Managing international trade regulations, export documentation, and ensuring smooth customs clearance."
  }
];

export const companyValues = [
  {
    id: 1,
    title: "Quality Excellence",
    description: "We never compromise on quality. Every product undergoes stringent checks to meet international standards."
  },
  {
    id: 2,
    title: "Customer Commitment",
    description: "Building lasting partnerships through trust, transparency, and exceptional service to our global clients."
  },
  {
    id: 3,
    title: "Ethical Sourcing",
    description: "Committed to responsible sourcing practices and maintaining ethical standards throughout our supply chain."
  },
  {
    id: 4,
    title: "Innovation",
    description: "Continuously improving our processes and product offerings to stay ahead in competitive international markets."
  }
];